import { render, staticRenderFns } from "./techbooks.vue?vue&type=template&id=2cd9bb24&"
import script from "./techbooks.vue?vue&type=script&lang=js&"
export * from "./techbooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports